import React, { useState } from "react";
import { Card, Form, Row, Col, Select, Button, Spin, DatePicker, message } from "antd";
import { errHandler } from "../../helper/helper";
import { getLoanProgressReport } from "./LoanService";
import generateLoanProgressReportExcel from "../../Utils/Loan/LoanProgressReportExcel";
import BranchLocationMultipleSelector from "../BranchLocationMultipleSelector";

const { Option } = Select;

const STATUS_OPTIONS = [
    { value: -1, label: "All" },
    { value: 0, label: "Active" },
    { value: 1, label: "Non-Performing" },
    { value: 2, label: "Closed" },
    { value: 3, label: "Other" },
];

const LoanProgressReport = ({ loginPlaceId, loanProducts, districtData, districtName, divisionalId, branchId }) => {
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState(-1);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [locationData, setLocationData] = useState({});

    const generateReport = async () => {
        setLoading(true);
        try {
            let statusList = null;
            if (statusFilter === 0) statusList = ["Active"];
            else if (statusFilter === 1) statusList = ["Non-Performing"];
            else if (statusFilter === 2) statusList = ["Closed"];
            else if (statusFilter === 3) statusList = ["Other"];

            const payload = {
                productIdList: selectedProducts.length > 0 ? selectedProducts : null,
                branchIdList: locationData.branchIds && locationData.branchIds.length > 0
                    ? locationData.branchIds
                    : (loginPlaceId === "1" && branchId ? [branchId] : null),
                dateFrom: dateRange && dateRange[0] ? dateRange[0].format("YYYY-MM-DD") : null,
                dateTo: dateRange && dateRange[1] ? dateRange[1].format("YYYY-MM-DD") : null,
                statusList,
            };

            const response = await getLoanProgressReport(payload);
            const rawData = Array.isArray(response) ? response : [];

            if (rawData.length === 0) {
                message.warning("No data found for the selected parameters");
                return;
            }

            const statusLabel = STATUS_OPTIONS.find(s => s.value === statusFilter)?.label || "All";
            await generateLoanProgressReportExcel(rawData, statusLabel);
            message.success("Report generated successfully");
        } catch (error) {
            console.error(error);
            errHandler(error?.message || "Failed to generate report");
        } finally {
            setLoading(false);
        }
    };

    const isGenerateDisabled = loading;

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <BranchLocationMultipleSelector loginPlaceId={loginPlaceId} districtData={districtData} districtName={districtName} divisionalId={divisionalId} branchId={branchId} onChange={setLocationData} />

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Product">
                                <Select
                                    mode="multiple"
                                    placeholder="Select product"
                                    style={{ width: "100%" }}
                                    value={selectedProducts}
                                    onChange={setSelectedProducts}
                                    allowClear
                                    showSearch
                                    maxTagCount="responsive"
                                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                >
                                    {loanProducts.map(p => (
                                        <Option key={p.productId} value={p.productId}>{p.productCode}-{p.productName}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Loan Status">
                                <Select
                                    placeholder="Select status"
                                    style={{ width: "100%" }}
                                    value={statusFilter}
                                    onChange={(value) => setStatusFilter(value)}
                                >
                                    {STATUS_OPTIONS.map(s => (
                                        <Option key={s.value} value={s.value}>{s.label}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Date Range">
                                <DatePicker.RangePicker
                                    style={{ width: "100%" }}
                                    value={dateRange}
                                    onChange={(dates) => setDateRange(dates || [])}
                                    format="YYYY-MM-DD"
                                    placeholder={["From date", "To date"]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    type="primary"
                                    onClick={generateReport}
                                    disabled={isGenerateDisabled}
                                    className="generate-btn"
                                    size="large"
                                    block
                                >
                                    {loading ? <Spin /> : "Generate Report"}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default LoanProgressReport;
